/**
 * Custom hook to handle fetching details from API
 * @param {String} API_MTSE_URL - The base URL for the API
 * @param {Function} setSelectedPrecatorio - State setter for the selected precatório
 * @param {Function} setIsModalOpen - State setter for modal open state
 * @param {Function} setLoadingDetails - State setter for loading state
 * @param {Function} setDetailsError - State setter for error state
 * @param {Function} setJurisconsultDetails - State setter for details data
 * @param {Function} toast - Toast function for notifications
 * @param {Function} setEscavadorDetails - State setter for Escavador data
 * @returns {Function} - Handler function for opening details
 */
export const useHandleOpenDetails = (
  API_MTSE_URL,
  setSelectedPrecatorio,
  setIsModalOpen,
  setLoadingDetails,
  setDetailsError,
  setJurisconsultDetails,
  toast,
  setEscavadorDetails
) => {
  return async (precatorio) => {
    setSelectedPrecatorio(precatorio);
    setIsModalOpen(true);
    setLoadingDetails(true);
    setDetailsError(null);
    setJurisconsultDetails(null);
    setEscavadorDetails(null);
    
    try {
      // Fetch both APIs in parallel
      const [jurisconsultResponse, escavadorResponse] = await Promise.allSettled([
        // Original Jurisconsult API
        fetch(`${API_MTSE_URL}/precatorioMT/jurisconsult/${precatorio._id}`),
        // Busca API - using the numero_precatorio to fetch process details
        fetch(`${API_MTSE_URL}/precatorioMT/jurisconsult/${precatorio._id}`)
      ]);
      
      // Handle Jurisconsult response
      if (jurisconsultResponse.status === 'fulfilled') {
        const response = jurisconsultResponse.value;
        if (response.ok) {
          const data = await response.json();
          if (data && data.success === true && data.data) {
            setJurisconsultDetails(data.data);
          }
        }
      }
      
      // Handle Escavador response
      if (escavadorResponse.status === 'fulfilled') {
        const response = escavadorResponse.value;
        if (response.ok) {
          const data = await response.json();
          if (data) {
            setEscavadorDetails(data);
          }
        }
      }
      
      // Check if at least one API returned data
      if (jurisconsultResponse.status === 'rejected' && escavadorResponse.status === 'rejected') {
        throw new Error('Não foi possível obter detalhes de nenhuma fonte');
      }
      
    } catch (error) {
      console.error('Erro ao buscar detalhes:', error);
      setDetailsError(error.message);
      
      toast({
        title: 'Erro ao buscar detalhes',
        description: error.message,
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setLoadingDetails(false);
    }
  };
};
